import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=d37d09a0&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=d37d09a0&prod&scoped=true&lang=css&"
import style1 from "./NotificationsBell.vue?vue&type=style&index=1&id=d37d09a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37d09a0",
  null
  
)

export default component.exports